import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["addButton", "section"]
  static values = { 
    contactId: Number,
    fieldType: String
  }

  connect() {
    console.log('ContactFieldsController connected')
    this.setupHoverEffects()
    // Removed setupAddButtons() - Stimulus handles this via data-action
  }

  setupHoverEffects() {
    // Add subtle hover effects for better UX
    this.element.addEventListener('mouseenter', () => {
      this.addButtonTargets.forEach(button => {
        button.classList.add('show')
      })
    })

    this.element.addEventListener('mouseleave', () => {
      this.addButtonTargets.forEach(button => {
        button.classList.remove('show')
      })
    })
  }

  addField(event) {
    console.log('addField called')
    const button = event.currentTarget
    const fieldType = button.dataset.fieldType
    const section = button.closest('.contact-section').querySelector('.contact-fields-list')
    
    console.log('Field type:', fieldType)
    console.log('Section found:', section)
    
    // Get the template for the new field
    const time = new Date().getTime()
    
    // Create the appropriate field template based on type
    let template = this.getFieldTemplate(fieldType, time)
    
    // Add the new field to the section
    section.insertAdjacentHTML('beforeend', template)
    
    // Animate the new field in
    const newField = section.lastElementChild
    if (newField) {
      newField.style.opacity = '0'
      newField.style.transform = 'translateY(-10px)'
      requestAnimationFrame(() => {
        newField.style.transition = 'all 0.3s ease'
        newField.style.opacity = '1'
        newField.style.transform = 'translateY(0)'
      })
      
      // Focus the first input in the new field
      const firstInput = newField.querySelector('input:not([type="hidden"])')
      if (firstInput) {
        firstInput.focus()
      }
    }
  }

  getFieldTemplate(fieldType, time) {
    const fieldName = `contact[${fieldType}_attributes][${time}]`
    
    switch(fieldType) {
      case 'email_addresses':
        return `
          <div class="contact-field-item email-field">
            <div class="field-content">
              <div class="field-inputs">
                <input type="text" name="${fieldName}[label]" class="form-control field-label" placeholder="Label" value="Email" />
                <input type="email" name="${fieldName}[info]" class="form-control field-value" placeholder="email@example.com" />
              </div>
              <div class="field-actions">
                <input type="hidden" name="${fieldName}[_destroy]" value="false" />
                <button type="button" class="btn btn-sm btn-outline-danger remove-field" 
                        data-action="click->contact-fields#removeField">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>
          </div>
        `
      case 'phone_numbers':
        return `
          <div class="contact-field-item phone-field">
            <div class="field-content">
              <div class="field-inputs">
                <input type="text" name="${fieldName}[label]" class="form-control field-label" placeholder="Label" value="Phone" />
                <input type="tel" name="${fieldName}[number]" class="form-control field-value" placeholder="(555) 123-4567" />
                <input type="text" name="${fieldName}[ext]" class="form-control field-extra" placeholder="Ext." />
                <input type="text" name="${fieldName}[country]" class="form-control field-extra small" placeholder="Country" value="US" />
              </div>
              <div class="field-actions">
                <input type="hidden" name="${fieldName}[_destroy]" value="false" />
                <button type="button" class="btn btn-sm btn-outline-danger remove-field" 
                        data-action="click->contact-fields#removeField">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>
          </div>
        `
      case 'addresses':
        return `
          <div class="contact-field-item address-field">
            <div class="field-content">
              <div class="field-inputs">
                <input type="text" name="${fieldName}[label]" class="form-control field-label" placeholder="Label" value="Address" />
                <input type="text" name="${fieldName}[street]" class="form-control field-value primary" placeholder="Street Address" />
                <div class="address-details">
                  <input type="text" name="${fieldName}[city]" class="form-control field-extra" placeholder="City" />
                  <input type="text" name="${fieldName}[state]" class="form-control field-extra small" placeholder="State" maxlength="2" />
                  <input type="text" name="${fieldName}[zip]" class="form-control field-extra" placeholder="Zip" />
                </div>
              </div>
              <div class="field-actions">
                <input type="hidden" name="${fieldName}[_destroy]" value="false" />
                <button type="button" class="btn btn-sm btn-outline-danger remove-field" 
                        data-action="click->contact-fields#removeField">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>
          </div>
        `
      case 'websites':
        return `
          <div class="contact-field-item website-field">
            <div class="field-content">
              <div class="field-inputs">
                <input type="text" name="${fieldName}[label]" class="form-control field-label" placeholder="Label" value="Website" />
                <input type="url" name="${fieldName}[info]" class="form-control field-value" placeholder="https://example.com" />
              </div>
              <div class="field-actions">
                <input type="hidden" name="${fieldName}[_destroy]" value="false" />
                <button type="button" class="btn btn-sm btn-outline-danger remove-field" 
                        data-action="click->contact-fields#removeField">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>
          </div>
        `
      default:
        return ''
    }
  }

  // Handle field removal
  removeField(event) {
    event.preventDefault()
    const fieldContainer = event.target.closest('.contact-field-item')
    const destroyInput = fieldContainer.querySelector('input[name*="_destroy"]')
    
    // Animate out
    fieldContainer.style.transition = 'all 0.3s ease'
    fieldContainer.style.opacity = '0'
    fieldContainer.style.transform = 'translateX(-20px)'
    
    setTimeout(() => {
      if (destroyInput) {
        destroyInput.value = "1"
        fieldContainer.style.display = 'none'
      } else {
        fieldContainer.remove()
      }
    }, 300)
  }

  // Auto-save on blur (optional enhancement)
  autoSave(event) {
    if (event.target.dataset.autoSave === 'true') {
      // Debounced auto-save could go here
      clearTimeout(this.saveTimeout)
      this.saveTimeout = setTimeout(() => {
        // Auto-save logic
      }, 1000)
    }
  }
}